import { ProductInfoType } from '@/api/fetchProductData'
import Service, { getCallApiFunction } from '../service'

// 推薦商品（shop-api /v1/product/recommend/*）：結果每小時重算，已過濾不可購買、沒庫存、非當前幣別的商品
// for-you 依會員的購買紀錄、偏好分類與最近看過的商品（未登入只看這台裝置的瀏覽）；沒有任何紀錄時後端回熱門（source 為 hot）
// cart 依購物車內的商品（productIds）；購物車是空的時後端回熱門
// recently-viewed 最近看過（visitorId + 登入會員）
export type ProductRecommendType = 'hot' | 'similar' | 'also-bought' | 'for-you' | 'cart' | 'recently-viewed'

// 推薦來源：newest 是熱門不足時用新上架補位；preference 是為你推薦裡來自偏好分類的；pinned 是後台指定；live 是正在直播的商品
export type ProductRecommendSource =
  | 'hot'
  | 'newest'
  | 'similar'
  | 'also_bought'
  | 'also_viewed'
  | 'preference'
  | 'pinned'
  | 'live'
  | 'recently_viewed'

export type ParamsType = {
  type: ProductRecommendType
  productId?: number | string // similar / also-bought 必填
  limit?: number // 不帶用後台設定的顯示數量
  categoryId?: number // 只給 hot：限定分類（含子分類）
  excludeIds?: (number | string)[] // 只給 hot：排除同頁其他區塊已出現的商品
  productIds?: (number | string)[] // 只給 cart：購物車內的商品，最多 60 個
  visitorId?: string // 只給 for-you / recently-viewed：訪客 id（getVisitorId）
}

class FetchProductRecommendApi extends Service {
  constructor({ type, productId, limit, categoryId, excludeIds, productIds, visitorId }: ParamsType) {
    super()
    this.name = 'FETCH_PRODUCT_RECOMMEND'

    this.config = {
      url: ['similar', 'also-bought'].includes(type) ? `/v1/product/recommend/${type}/${productId}` : `/v1/product/recommend/${type}`,
      params: {
        limit,
        categoryId,
        excludeIds: excludeIds?.length ? excludeIds.join(',') : undefined,
        productIds: productIds?.length ? productIds.join(',') : undefined,
        visitorId: visitorId || undefined,
      },
      method: 'GET',
    }
  }
}

export type ProductRecommendResultType = {
  // 區塊來源：商品頁也買了夠多時為 also_bought，否則看了也看夠多時為 also_viewed，再否則為 similar（標題改「你可能也喜歡」）；
  // 為你推薦有個人化結果時為 for_you
  source: 'hot' | 'similar' | 'also_bought' | 'also_viewed' | 'for_you' | 'recently_viewed'
  alsoBoughtCount: number
  alsoViewedCount: number
  // 商品基本資料（同商品列表）加上 recommendSource
  items: (ProductInfoType & { productId: number; recommendSource: ProductRecommendSource })[]
}

export const fetchProductRecommend = (params: ParamsType): Promise<ProductRecommendResultType> =>
  getCallApiFunction(new FetchProductRecommendApi(params))
